import React, { useMemo } from 'react';
import '../../../styles/service-pages.scss';
import ServiceDetailCards from '../../../components/ServiceDetailCards';
import LatestWorkGrid from '../../../components/LatestWorkGrid';
import Seo from '../../../components/Seo';

const FractionalDesignServices = () => {
  const detailItems = useMemo(() => [
    {
      title: 'Approach',
      description:
        "We start by getting properly under the bonnet: your current design maturity, your team setup, what's working and what's quietly on fire. From there we agree a working rhythm that fits your sprints, your timelines, and the humans you work with. No 'alignment workshops' that could've been emails. Just proper embedded design work.",
    },
    {
      title: 'Delivery',
      description:
        "Flexible engagement models — from a day a week to full project sprints. You get direct Slack/Teams access, attendance at key meetings, and a designer who actually cares about your outcomes. Deliverables flex to whatever your product needs: flows, wireframes, prototypes, design system work, QA with developers, or strategic input at the roadmap level.",
    },
    {
      title: 'Results',
      description:
        "Teams working with a fractional designer typically see faster design-to-dev cycles, fewer rework loops, and a noticeable step-change in design quality without the overhead of a full-time hire. Plus someone to finally answer 'what should this button say' at 4pm on a Thursday.",
    },
  ], []);

  return (
    <>
      <Seo 
        title="Fractional Design Services | Heretic Studio"
        description="Get senior design expertise without the full-time cost. Embed into your team on a flexible basis, delivering strategic design, rapid iteration, and ongoing optimisation—exactly when you need it."
      />
      <div className="studio-page service-page service-page--fractional-design">
        <div className="studio-hero service-hero">
          <div className="studio-hero__content service-hero__content">
            <h1 className="studio-hero__title service-hero__title">Fractional Design</h1>
            <p className="studio-hero__subtitle service-hero__subtitle">Senior design talent. Without the full-time price tag.</p>
          </div>
        </div>

        <section className="section intro service-intro">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-12">
                <div className="blur-text blur-text--1 large center-text introtext">
                  Senior design expertise without the full-time cost.
                </div>
              </div>
            </div>
          </div>
        </section>

        <ServiceDetailCards items={detailItems} />

        <LatestWorkGrid />
      </div>
    </>
  );
};

export default FractionalDesignServices;
